module.exports = __webpack_public_path__ + "img/csu2.46d4ea72.jpg";